import { clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

// tailwind-merge doesn't know about tailwind.config.js's `tw-` prefix by
// default, so without this it can't tell `tw-bg-white` and `tw-bg-[#123]`
// are conflicting utilities — both would survive and CSS source order
// (not call order) would decide which one visually wins.
const twMerge = extendTailwindMerge({ prefix: 'tw-' });

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}
